import {z} from 'zod';

/**
 * Maps the values of a ZodObject schema to a new value schema.
 *
 * @param schema - The ZodObject schema to map the values of.
 * @param valueSchema - The new value schema to map the values to.
 * @returns A new ZodObject schema with the mapped values.
 */
export function zodMapObjectSchemaValues<
  T extends z.ZodRawShape,
  TValueSchema extends z.ZodTypeAny,
>(
  schema: z.ZodObject<T>,
  valueSchema: TValueSchema
): z.ZodObject<{
  [K in keyof T]: TValueSchema;
}> {
  const entries = Object.entries(schema.shape) as [keyof T, z.ZodTypeAny][];
  const mappedShape = entries.reduce(
    (acc, [key]) => ({
      ...acc,
      [key]: valueSchema,
    }),
    {} as {[K in keyof T]: TValueSchema}
  );

  return z.object(mappedShape) as z.ZodObject<{
    [K in keyof T]: TValueSchema;
  }>;
}
